import React from "react";
import { Card } from "../export";
import "./project.css";
import { linkChain, GitLink } from "../../Portfolio Asset/exportAsset";

import { motion } from "framer-motion";
import { projects } from "./index.js";

const Project = () => {
  return (
    <motion.div
      className="app__project"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <h1 className="h1__text2">Project</h1>
      <p className="p__text">Things I’ve built so far</p>

      <div className="app__project-card">
        {projects.map((project) => (
          <Card
            imgURL={project.imgURL}
            title={project.title}
            subText={project.subText}
            techStack={project.techStack}
            imglink={linkChain}
            live={project.live}
            gitlink={GitLink}
            github={project.github}
          />
        ))}
      </div>

      {/* <div className="app__project-card-2"></div> */}
    </motion.div>
  );
};

export default Project;
